import { MessageCircle } from 'lucide-react';
import { phrasePenseAVous } from './format';

/**
 * « Alexia Sestito pense à vous pour ce remplacement » : ce que voit un·e collègue qui a reçu le message personnel
 * (« Prévenir aussi personnellement »), dans « Demandes des collègues », le calendrier des collègues et la fiche.
 */
export function PenseAVous({ de }: { de: string }) {
  return (
    <div className="collegue-pense">
      <MessageCircle size={14} aria-hidden="true" />
      <span>{phrasePenseAVous(de)}</span>
    </div>
  );
}
